export default "__VITE_ASSET__BoQaozGN__"